"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MegaMenuLocationType = void 0;
var MegaMenuLocationType;
(function (MegaMenuLocationType) {
    MegaMenuLocationType[MegaMenuLocationType["BUILDING"] = 0] = "BUILDING";
    MegaMenuLocationType[MegaMenuLocationType["DISTRICT"] = 1] = "DISTRICT";
})(MegaMenuLocationType = exports.MegaMenuLocationType || (exports.MegaMenuLocationType = {}));
